// Bankgiro Inbetalningar, October 2023, sections 5.2.2 and 5.3.5.
// Positions are counted from the right, including the four trailing blanks.
export const BANKGIRO_SLIP_WIDTH_MM = 210.82;
export const BANKGIRO_SLIP_HEIGHT_MM = 101.6;
export const BANKGIRO_CELL_MM = 2.54;
export const BANKGIRO_CODE_BASELINE_MM = 84.6;

export function mod10CheckDigit(digits: string): string {
  let sum = 0;
  for (let i = digits.length - 1, weight = 2; i >= 0; i--, weight = 3 - weight) {
    const product = Number(digits[i]) * weight;
    sum += Math.floor(product / 10) + product % 10;
  }
  return String((10 - sum % 10) % 10);
}

export function bankgiroCodeLine(reference: string, bankgiro: string, amountOre: number): string | null {
  const account = bankgiro.replace('-', '');
  if (!/^\d{2,25}$/.test(reference) || !/^\d{3,4}-?\d{4}$/.test(bankgiro) ||
      mod10CheckDigit(reference.slice(0, -1)) !== reference.slice(-1) ||
      mod10CheckDigit(account.slice(0, -1)) !== account.slice(-1) ||
      !Number.isSafeInteger(amountOre) || amountOre <= 0 || amountOre > 9999999999) return null;

  const line = Array<string>(83).fill(' ');
  const put = (rightmostPosition: number, value: string) => {
    const start = 83 - rightmostPosition - value.length + 1;
    [...value].forEach((character, offset) => { line[start + offset] = character; });
  };
  put(83, 'H'); put(79, '#'); put(53, reference); put(51, '#');
  put(43, String(Math.floor(amountOre / 100)));
  put(40, String(amountOre % 100).padStart(2, '0'));
  put(36, mod10CheckDigit(String(amountOre))); put(34, '>');
  put(9, account); put(8, '#'); put(6, '41'); put(5, '#');
  return line.join('');
}
